import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {NoAccessState} from '@/components/no-access-state'
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/components/ui/tabs'
import {ResumenVitals} from '@/components/cartera/resumen-vitals'
import {PreciosTab} from '@/components/cartera/precios-tab'
import {FacturasTab} from '@/components/cartera/facturas-tab'
import {SuscripcionesTab} from '@/components/cartera/suscripciones-tab'
import {useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'
import {useCarteraResumen} from '@/hooks/inci/cartera/use-cartera'

export function CarteraPage() {
  const {t} = useTranslation()
  const isSystemUser = useIsSystemUser()
  const {data: resumen, isLoading} = useCarteraResumen(isSystemUser)

  if (!isSystemUser) return <NoAccessState />

  return (
    <div className="space-y-5" data-testid="cartera-page">
      <PageHeading title={t('cartera.title')} />

      <ResumenVitals resumen={resumen} isLoading={isLoading} />

      <Tabs defaultValue="precios">
        <TabsList>
          <TabsTrigger value="precios" data-testid="cartera-tab-precios">
            {t('cartera.tabs.precios')}
          </TabsTrigger>
          <TabsTrigger value="facturas" data-testid="cartera-tab-facturas">
            {t('cartera.tabs.facturas')}
          </TabsTrigger>
          <TabsTrigger value="suscripciones" data-testid="cartera-tab-suscripciones">
            {t('cartera.tabs.suscripciones')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="precios" className="pt-4">
          <PreciosTab />
        </TabsContent>

        <TabsContent value="facturas" className="pt-4">
          <FacturasTab />
        </TabsContent>

        <TabsContent value="suscripciones" className="pt-4">
          <SuscripcionesTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
